import { FC } from "react";

import dynamic from "next/dynamic";

import CompareIntegrations from "components/views/integrations/overview/compare-integrations";
import RelyOnMultipleTools from "components/views/integrations/overview/rely-on-multiple-tools";
import PartnerWithEnerflo from "components/views/integrations/partner-with-enerflo";

import Page from "../../components/layout/page";
import MainHero from "../../components/views/integrations/overview/main-hero";
import PlaysNice from "../../components/views/integrations/overview/plays-nice";

const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));
const Logos = dynamic(() => import("../../components/views/integrations/overview/logos"));

const Integrations: FC = () => (
  <Page
    title="Integrations for Residential Solar Sales & Fulfillment"
    description="Enerflo has the most integrations of any other solar platform, including software for solar sales qualification, proposals, design, finance, CRM and more."
  >
    <MainHero />
    <Logos />
    <PlaysNice />
    <CompareIntegrations />
    <RelyOnMultipleTools />
    <PartnerWithEnerflo />
    <DemoFormSection />
  </Page>
);

export default Integrations;
